import RouterHandler from "./RouterHandler";

function App() {
  return (
    <div className="App">
      <RouterHandler />
    </div>
  );
}

export default App;
